import { NavigationStart, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { Injectable } from '@angular/core';

export enum LayoutOptimizationType {
  Nothing = 0,
  Full = 1,
}
@Injectable({
  providedIn: 'root',
})
export class LayoutOptimizationService {
  private optimization$: Subject<LayoutOptimizationType> = new Subject<
    LayoutOptimizationType
  >();
  private isStarted$: Subject<boolean> = new Subject<boolean>();
  private _isStarted = false;

  constructor(private router: Router) {
    if (router) {
      router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.optimize(LayoutOptimizationType.Nothing);
        }
      });
    }
  }

  start(): void {
    this.isStarted$.next(true);
    this._isStarted = true;
  }
  stop(): void {
    this.isStarted$.next(false);
    this._isStarted = false;
    this.optimization$.next(LayoutOptimizationType.Nothing);
  }

  isStarted() {
    return this._isStarted;
  }
  getIsStarted(): Observable<boolean> {
    return this.isStarted$;
  }

  optimize(optimizationType: LayoutOptimizationType): void {
    if (this._isStarted) {
      this.optimization$.next(optimizationType);
    }
  }

  getOptimization(): Observable<LayoutOptimizationType> {
    return this.optimization$;
  }
}
